<script>
    export default {
        mounted() {
            this.loadActiveUsersCounts();
        },
        data() {
            return {
                activeUsersCounts: {
                    'cnt_logins_week': 'n/a',
                    'cnt_logins_month': 'n/a',
                    'cnt_logins_year': 'n/a',
                },
            }
        },
        methods: {
            loadActiveUsersCounts() {
                axios.get(`${Scoop.baseUrl}/api/components/statisticActiveUsers`).then(res => {
                    this.activeUsersCounts = res.data;
                })
            },
        }
    }
</script>

<template>
    <div class="ibox">
        <div class="ibox-title">
            <h5>Active users</h5>
        </div>
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-4">
                    <small class="stats-label">Last week</small>
                    <h4 v-text="activeUsersCounts.cnt_logins_week"></h4>
                </div>
                <div class="col-sm-4">
                    <small class="stats-label">Last month</small>
                    <h4 v-text="activeUsersCounts.cnt_logins_month"></h4>
                </div>
                <div class="col-sm-4">
                    <small class="stats-label">Last year</small>
                    <h4 v-text="activeUsersCounts.cnt_logins_year"></h4>
                </div>
            </div>
        </div>
    </div>
</template>
